import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import {
  IState,
  ISuccessAction,
  IFailureAction,
} from "interfaces/paginate-duck";
import { TransitsAr } from "interfaces/transit-time-ar";

const { Types, Creators } = createActions(
  {
    request: ["query"],
    success: ["data", "pagination"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "PAGINATE_TRANSITS_AR_" }
);

export interface PaginateTransitsArState extends IState {
  data: TransitsAr[] | Record<string, any>[];
}

const INITIAL_STATE: PaginateTransitsArState = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

const request = (state: PaginateTransitsArState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: PaginateTransitsArState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (state: PaginateTransitsArState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const paginateTransitsAr = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const PaginateTransitsArTypes = Types;
export const PaginateTransitsArActions = Creators;
